<ng-container [formGroup]="shipment.shipmentForm$ | async">
   <mat-expansion-panel id="tradeshow" class="bordered tradeshow" *ngIf="tradeshow?.length">
      <mat-expansion-panel-header>
         <mat-panel-title id="tradeshowPanelTitle">
            Tradeshow Details
         </mat-panel-title>
      </mat-expansion-panel-header>

      <div formArrayName="tradeshow">
         <ng-container *ngFor="let show of tradeshow.controls; index as i">
            <div class="overline">{{show.get('location').value | uppercase}}</div>
            <div class="flex" [formGroupName]="i">
               <mat-form-field>
                  <input [id]="show.get('location').value+'ShowNameInput'" matInput placeholder="Show Name" formControlName="name" [maxlength]="config?.items?.name?.maxLength" />
                  <mat-error [id]="show.get('location').value+'ShowNameError'" libInputErrors [control]="show.get('name')"></mat-error>
                  <mat-hint [id]="show.get('location').value+'ShowNameHint'" align="end" *ngIf="config?.items?.name?.maxLength && show.get( 'name' ).value?.length as l">
                     {{l || 0}} / {{config?.items?.name?.maxLength}}
                  </mat-hint>
               </mat-form-field>
               <mat-form-field>
                  <input [id]="show.get('location').value+'BoothInput'" matInput placeholder="Booth Number" formControlName="booth" [maxlength]="config?.items?.booth?.maxLength" />
                  <mat-error [id]="show.get('location').value+'BoothError'" libInputErrors [control]="show.get('booth')"></mat-error>
                  <mat-hint [id]="show.get('location').value+'BoothHint'" align="end" *ngIf="config?.items?.booth?.maxLength && show.get( 'booth' ).value?.length as l">
                     {{l || 0}} / {{config?.items?.booth?.maxLength}}
                  </mat-hint>
               </mat-form-field>
               <mat-form-field>
                  <input [id]="show.get('location').value+'ExhibitorInput'" matInput placeholder="Exhibitor" formControlName="exhibitor" [maxlength]="config?.items?.exhibitor?.maxLength" />
                  <mat-error [id]="show.get('location').value+'ExhibitorError'" libInputErrors [control]="show.get('exhibitor')"></mat-error>
                  <mat-hint [id]="show.get('location').value+'ExhibitorHint'" align="end" *ngIf="config?.items?.exhibitor?.maxLength && show.get( 'exhibitor' ).value?.length as l">
                     {{l || 0}} / {{config?.items?.exhibitor?.maxLength}}
                  </mat-hint>
               </mat-form-field>
            </div>
         </ng-container>
      </div>
   </mat-expansion-panel>
</ng-container>
